import { useQuery } from '@apollo/client';
import {
  GetExternalProjectImportPreviewInput,
  GetExternalProjectImportPreviewResponse,
} from '@provision/entity-types';
import {
  GET_DTOOLS_PROJECT_IMPORT_PREVIEW,
} from 'src/graphql/entities/integrations/dtools/dtools.operations';
import { useGlobalStore } from 'src/store';
import { useNotifications } from 'src/utils/hooks';

export const useDtoolsProjectImportPreview = (projectIds: string[]) => {
  const { showErrorAlert } = useNotifications();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();
  const { data, loading } = useQuery<
    {
      getDtoolsProjectImportPreview: GetExternalProjectImportPreviewResponse<string>;
    },
    GetExternalProjectImportPreviewInput<string>
  >(GET_DTOOLS_PROJECT_IMPORT_PREVIEW, {
    variables: {
      params: {
        projectIds,
        partnerId: selectedPartnerId!,
      },
    },
    skip: !selectedPartnerId || projectIds.length === 0,
    onError: (data) => {
      showErrorAlert(data.message);
    },
  });

  return {
    records: data?.getDtoolsProjectImportPreview.records,
    errors: data?.getDtoolsProjectImportPreview.errors,
    loading,
  };
};
